import { Button, Intent, MaybeElement } from "@blueprintjs/core";
import { IconName, IconNames } from "@blueprintjs/icons";
import { FormikProps } from "formik";
import { ButtonContainer } from "nsitools-react";
import * as React from "react";
import { useHistory } from "react-router";

import { useTl } from "../../hooks";
import { ETLCodes } from "../../locales";
import { EDrupalRoutes } from "../EDrupalRoutes";

export interface IDrupalStepperButtonBlocProps {
  disabled?: boolean;
  loading?: boolean;
  onStepChange?: (newStep: number) => void;
  stepNumber?: number;
  onNextFn?: (data?: any) => Promise<any> | any;
  nextButtonText?: string;
  nextButtonIcon?: IconName | MaybeElement;
  formik?: FormikProps<any>;
  backOnly: boolean;
  forceStepperBack?: boolean;
}

export const DrupalStepperButtonBloc: React.FunctionComponent<IDrupalStepperButtonBlocProps> = ({
  disabled = false,
  loading = false,
  onStepChange = null,
  stepNumber = 0,
  onNextFn,
  nextButtonText,
  nextButtonIcon,
  formik = null,
  backOnly,
  forceStepperBack = false,
}) => {
  const { t } = useTl();
  const history = useHistory();
  const [currentStep, setcurrentStep] = React.useState(stepNumber);

  const onChange = React.useCallback(
    (nextStep) => {
      const st = currentStep;
      const step = nextStep < 0 ? 0 : nextStep > 2 ? 2 : nextStep;
      setcurrentStep(step);
      try {
        onStepChange(step);
      } catch {
        setcurrentStep(st);
      }
    },
    [currentStep, onStepChange]
  );

  const onNext = () => {
    if (formik) {
      console.log("next");
      Object.keys(formik.values).map((c) => formik.setFieldTouched(c, true, true));
      if (Object.keys(formik.errors).length > 0) {
        console.log("errors", formik?.errors);
        return;
      }
    }
    if (onNextFn) {
      onNextFn();
    }
    console.log("next", currentStep);
    onChange(currentStep + 1);
  };
  const onPrevious = React.useCallback(
    () =>
      !forceStepperBack && (currentStep === 0 || backOnly || stepNumber === 2)
        ? history.push(EDrupalRoutes.requestList)
        : onChange(currentStep - 1),
    [backOnly, currentStep, forceStepperBack, history, onChange, stepNumber]
  );
  return (
    <ButtonContainer style={{ margin: "0.5em" }}>
      <Button
        text={t(ETLCodes.General_GoBack)}
        onClick={onPrevious}
        style={{ margin: "0.5em" }}
        icon={IconNames.CHEVRON_LEFT}
        loading={loading}
      />
      {backOnly ? (
        <div />
      ) : (
        <Button
          text={nextButtonText || t(ETLCodes.Next)}
          onClick={onNext}
          disabled={disabled}
          intent={Intent.PRIMARY}
          style={{ margin: "0.5em" }}
          rightIcon={nextButtonIcon || IconNames.CHEVRON_RIGHT}
          loading={loading}
        />
      )}
    </ButtonContainer>
  );
};
